import First from 'components/back_request/First';
import PageTemplate from 'components/template/PageTemplate';

const Shipment = () => {
    return (
        <PageTemplate background='black' isFooter={false}>
            <First />
        </PageTemplate>
    )
}

export default Shipment